/* ==========================================================================
   CSA Real Stories JavaScript
   Swiper Slider & Theme Editor Realtime Lifecycle Management
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCSARealStoriesSliders();
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section-csa-real-stories') || event.target.querySelector('.csa-real-swiper')) {
    initCSARealStoriesSection(event.target);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  const blockEl = event.target;
  const sectionEl = blockEl.closest('.csa-real-section');
  if (sectionEl) {
    const swiperEl = sectionEl.querySelector('.csa-real-swiper');
    if (swiperEl && swiperEl.swiperInstance) {
      const slideIndex = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(blockEl);
      if (slideIndex !== -1) {
        swiperEl.swiperInstance.slideTo(slideIndex);
      }
    }
  }
});

function initCSARealStoriesSliders() {
  const sections = document.querySelectorAll('.csa-real-section');
  sections.forEach(function (section) {
    initCSARealStoriesSection(section);
  });
}

function initCSARealStoriesSection(section) {
  const swiperEl = section.querySelector('.csa-real-swiper');
  if (!swiperEl) return;

  if (swiperEl.swiperInstance) {
    swiperEl.swiperInstance.destroy(true, true);
    swiperEl.swiperInstance = null;
  }

  const prevBtn = section.querySelector('.csa-real-prev');
  const nextBtn = section.querySelector('.csa-real-next');
  const paginationEl = section.querySelector('.csa-real-pagination');

  if (typeof Swiper !== 'undefined') {
    const swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });

    swiperEl.swiperInstance = swiperInstance;

    setTimeout(function () {
      if (swiperInstance && !swiperInstance.destroyed) {
        swiperInstance.update();
      }
    }, 100);
  }
}
